import { configureStore } from '@reduxjs/toolkit';

// slices
import usersSlice from './usersSlice';
import rolesSlice from './rolesSlice';
import vendorsSlice from './vendorsSlice';
import stockSlice from './stockSlice';
import stockSettingSlice from './stockSettingSlice';
import purchaseOrdersSlice from './purchaseOrdersSlice';

export const store = configureStore({
  reducer: {
    users: usersSlice,
    roles: rolesSlice,
    vendors: vendorsSlice,
    stock: stockSlice,
    stockSetting: stockSettingSlice,
    purchaseOrders: purchaseOrdersSlice,
  },
});

export default store;
